import { render, staticRenderFns } from "./wx-pay-apply-modal.vue?vue&type=template&id=35730326&"
import script from "./wx-pay-apply-modal.vue?vue&type=script&lang=js&"
export * from "./wx-pay-apply-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports